import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import { FormControl } from "@material-ui/core";
import { phoneMask, cnpjMask } from "../../utils/mask";
import { BrandsApi } from "../../services/Apis";
import alertMessage from "../../services/alertMessage";
import { CustomTextField, CustomLabel } from "@tracknme/material-ui";
import { cnpj } from "cpf-cnpj-validator";
import "../../App.css";
import "../../menu.css";

function Step1() {
  const dispatch = useDispatch();

  const { register, navigation } = useSelector(({ register }) => register);

  const [name, setName] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [alias, setAlias] = useState(null);
  const [aliasError, setAliasError] = useState(null);
  const [email, setEmail] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [whatsapp, setWhatsapp] = useState(null);
  const [whatsappError, setWhatsappError] = useState(null);
  const [phone, setPhone] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [registrationNumber, setRegistrationNumber] = useState(null);
  const [validationRegistrationNumber, setValidationRegistrationNumber] =
    useState(true);
  const [corporateName, setCorporateName] = useState(null);
  const [corporateNameError, setCorporateNameError] = useState(null);
  const [loadData, setLoadData] = useState(false);

  useEffect(() => {
    if (!loadData && register && register.brand) {
      setName(register.brand.name);
      setAlias(register.brand.alias);

      let registrationNumber = cnpjMask(register.brand.registrationNumber);
      setRegistrationNumber(registrationNumber);

      if (registrationNumber.length > 17) {
        setValidationRegistrationNumber(true);
      }

      setCorporateName(register.brand.corporateName);
      setLoadData(true);
      setCorporateNameError(false);
      setCorporateNameError(false);
      setNameError(false);
      dispatch(Actions.setNavigation(false));
    }
  }, [loadData, register, dispatch]);

  const handleChangeEmailValue = ({ target }) => {
    const { value } = target;
   
    setEmail(value);
  };

  const handleChangeWhatsappValue = ({ target }) => {
    const { value } = target;
    let phone = phoneMask(value);
    setWhatsapp(phone);
  };

  const handleChangePhoneValue = ({ target }) => {
    const { value } = target;
    let phone = phoneMask(value);
    setPhone(phone);
  };

  const handleChangeNameValue = ({ target }) => {
    const { value } = target;
    const valueName = String(value).replace(/[^a-zA-Z0-9 ]/g, '');
    setName(valueName);

    const valueAlias = String(value).toLocaleLowerCase().replace(/[^a-z0-9]/g, '').replace(/ /g, "_").replace(/www/g, '').replace(/dev/g, '');
    setAlias(valueAlias);
  };

  const handleChangeRegistrationNumberValue = ({ target }) => {
    const { value } = target;
    let registrationNumber = cnpjMask(value);
    setRegistrationNumber(registrationNumber);

    if (registrationNumber.length > 17) {
      setValidationRegistrationNumber(true);
    }
  };

  function validateBrandCnpj() {
    let cnpj = registrationNumber.replace(/[^\d]+/g, "");
    BrandsApi.checkRegistrationNumber(cnpj)
      .then((response) => {
        if (response.data === 0) {
          setValidationRegistrationNumber(true);
        } else {
          alertMessage.showErrorMessage(
            "Esse CNPJ já está cadastrado na Plataforma!"
          );
          setValidationRegistrationNumber(false);
        }

        return;
      })
      .catch((error) => {
        return;
      });
  }

  const maskOnlyLetters = (value) => {
    if (value) {
      let v = "" + value;
      return v.replace(/[^a-z0-9_]/g, "");
    } else {
      return "";
    }
  };

  const handleChangeCorporateNameValue = ({ target }) => {
    const { value } = target;
    setCorporateName(value);
  };

  function validateName() {
    if (!name) {
      setNameError(true);
      return;
    }
    if (name && name.length < 3) {
      setNameError(true);
      return;
    }

    if(String(name).toLowerCase().includes('www') || String(name).toLowerCase().startsWith('dev')) {
      setNameError(true);
      alertMessage.showErrorMessage("No nome da marca não pode possuir 'www' ou 'dev'");
      return;
    }

    setNameError(false);
  }

  function validateEmail() {
    if (!email) {
      setEmailError(true);
      return;
    }

    setEmailError(false);
  }

  function validateWhatsapp() {
    if (!whatsapp) {
      setWhatsappError(true);
      return;
    }

    setWhatsappError(false);
  }

  function validatePhone() {
    if (!phone) {
      setPhoneError(true);
      return;
    }

    setPhoneError(false);
  }

  function validateAlias() {
    if (!alias) {
      setAliasError(true);
      return;
    }

    setAliasError(true);
    dispatch(Actions.setNavigation(true));

    BrandsApi.checkAlias(alias)
      .then((response) => {
        if (response.data === 0) {
          setAliasError(false);
        } else {
          alertMessage.showErrorMessage("Esse alias não está disponível!");
          setAliasError(true);
          dispatch(Actions.setNavigation(true));
        }

        return;
      })
      .catch((error) => {
        setAliasError(true);
        return;
      });
  }

  function validateCorporateName() {
    if (!corporateName) {
      setCorporateNameError(true);
      return;
    }
    if (corporateName && corporateName.length < 3) {
      setCorporateNameError(true);
      return;
    }

    setCorporateNameError(false);
  }

  function validateCNPJ() {
    if (!registrationNumber) {
      setValidationRegistrationNumber(false);
      dispatch(Actions.setNavigation(true));
      return;
    }

    if (!cnpj.isValid(registrationNumber)) {
      setValidationRegistrationNumber(false);
      alertMessage.showErrorMessage("CNPJ inválido!");
      dispatch(Actions.setNavigation(true));
      return;
    }

    validateBrandCnpj(registrationNumber);

    setValidationRegistrationNumber(false);
    dispatch(Actions.setNavigation(true));
  }

  function numberFormat(value) {
    if (value) {
      let v = value + "";
      return v.replace(/\D/g, "");
    } else {
      return "";
    }
  }

  useEffect(() => {
    if (
      name &&
      alias &&
      registrationNumber &&
      registrationNumber.length > 17 &&
      validationRegistrationNumber &&
      corporateName &&
      !aliasError &&
      !corporateNameError &&
      !nameError &&
      cnpj.isValid(registrationNumber)
    ) {
      dispatch(Actions.setNavigation(false));

      let _register = register;

      let primaryColor = "mat-fuse-dark-A700-bg";
      let secondColorBrand = "mat-fuse-dark-A400-bg";

      localStorage.setItem("primaryColorBrand", primaryColor);
      localStorage.setItem("secondColorBrand", secondColorBrand);

      if (_register && _register.brand) {
        _register.brand = {
          parent: 6137206846521344,
          name: name,
          alias: alias,
          corporateName: corporateName,
          registrationNumber: registrationNumber.replace(/\D/g, ""),
          companySize: _register.brand.companySize
            ? _register.brand.companySize
            : "",
          palette: _register.brand.palette
            ? _register.brand.palette
            : "fuse-dark",
          purposeOfUse: _register.brand.purposeOfUse
            ? _register.brand.purposeOfUse
            : [],
          email: email,
          whatsapp: numberFormat(whatsapp, false),
          phone: numberFormat(phone, false),
        };
      } else {
        _register = {
          brand: {
            parent: 6137206846521344,
            name: name,
            alias: alias,
            corporateName: corporateName,
            registrationNumber: registrationNumber.replace(/\D/g, ""),
            companySize: "",
            palette: "fuse-dark",
            purposeOfUse: [],
            email: email,
            whatsapp: numberFormat(whatsapp, false),
            phone: numberFormat(phone, false),
          },
        };
      }

      _register["payment"] = {
        type: "BOOKLET",
      };

      _register.skipCnaeCheck = false;
      _register.offer = "5891544202084352";

      dispatch(Actions.setRegister(_register));
    } else if (!navigation) {
      dispatch(Actions.setNavigation(true));
    }
  }, [
    name,
    alias,
    registrationNumber,
    corporateName,
    validationRegistrationNumber,
    register,
    dispatch,
    aliasError,
    corporateNameError,
    nameError,
    navigation,
    email,
    whatsapp,
    phone,
  ]);

  return (
    <div>
      <div className="titleStep1">
        <CustomLabel
          id="title"
          label="Vamos começar coletando alguns dados da sua empresa:"
          color="initial"
          component="h6"
          variant="h6"
          style={{ fontSize: "2.5vh", fontWeight: "bold", color: "#4D39E9" }}
        />
      </div>
      {/* {steps > 0 &&( */}
      <div className="form_top">
        <div className="conteudoStep1">
          <FormControl disabled={false}>
            <CustomTextField
              id="inputOne_1"
              label="Nome da Empresa:"
              value={name}
              name="inputOne_1"
              onBlur={() => validateName()}
              onChange={handleChangeNameValue}
              variant="filled"
              placeholder="Nome da Empresa"
              style={{ width: "25vw" }} //55vh
              error={nameError}
            />
          </FormControl>

          <div>
            {" "}
            <CustomTextField
              id="alias_1"
              label="Alias da Marca:"
              value={maskOnlyLetters(alias)}
              name="alias_1"
              onFocus={() => setAliasError(true)}
              onBlur={() => validateAlias()}
              // onChange={handleChangeAliasValue}
              variant="filled"
              placeholder="Alias da Marca"
              style={{ width: "17vw" }}
              error={aliasError}
              disabled={true}
              // onKeyPress={(e) => {
              //   if (e.target.value.includes("www")) {
              //     e.preventDefault();
              //     alertMessage.showErrorMessage(
              //       "Formato de Alias não permitido, no alias não pode conter www!"
              //     );
              //   }
              // }}
            />{" "}
          </div>
          <div style={{ marginTop: 40 }}>
            {" "}
            <CustomLabel
              id="standard-basic-data-picker"
              label=".tracknme.com.br"
              color="initial"
              component="h6"
              variant="h6"
              style={{ fontSize: 12, fontWeight: "700", color: "#4D39E9" }}
            />{" "}
          </div>
        </div>
      </div>
      {/* )} */}

      <div className="form_bottom">
      <div className="conteudo_bottom">
          <FormControl disabled={false}>
            <CustomTextField
              id="email"
              label="Email:"
              value={email}
              name="email"
              onBlur={() => validateEmail()}
              onChange={handleChangeEmailValue}
              variant="filled"
              placeholder="Email de contato"
              style={{ width: "46vw" }} //55vh
              error={emailError}
            />
          </FormControl>
          </div>
      </div>

      <div className="form_bottom">
      <div className="conteudo_bottom">
          <FormControl disabled={false}>
            <CustomTextField
              id="whatsapp"
              label="Whatsapp:"
              value={whatsapp}
              name="whatsapp"
              onBlur={() => validateWhatsapp()}
              onChange={handleChangeWhatsappValue}
              variant="filled"
              placeholder="Whatsapp"
              style={{ width: "20vw" }} 
              error={whatsappError}
            />
          </FormControl>

          <FormControl disabled={false}>
            <CustomTextField
              id="phone"
              label="Telefone:"
              value={phone}
              name="phone"
              onBlur={() => validatePhone()}
              onChange={handleChangePhoneValue}
              variant="filled"
              placeholder="Telefone"
              style={{ width: "25vw" }} 
              error={phoneError}
            />
          </FormControl>
          </div>
      </div>

      <div className="form_bottom">
        <div className="conteudo_bottom">
          <FormControl disabled={false}>
            <CustomTextField
              id="rs_1"
              label="Razão Social:"
              value={corporateName}
              onBlur={() => validateCorporateName()}
              name="rs_1"
              onChange={handleChangeCorporateNameValue}
              variant="filled"
              placeholder="Razão Social"
              style={{ width: "25vw" }}
              error={corporateNameError}
            />
          </FormControl>
          <FormControl disabled={false}>
            <CustomTextField
              id="cnpj_1"
              label="CNPJ:"
              value={registrationNumber}
              onFocus={() => setValidationRegistrationNumber(false)}
              onBlur={() => validateCNPJ()}
              name="cnpj_1"
              onChange={handleChangeRegistrationNumberValue}
              variant="filled"
              placeholder="00.000.000/0000-00"
              style={{ width: "25vw" }}
              error={!validationRegistrationNumber}
            />
          </FormControl>
        </div>
      </div>
    </div>
  );
}

export default Step1;
